import Class from './c-pagination-test';
import './c-pagination-test@';

export default Class;